
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ContractorsDocumentsFileredList from "@/components/documents/ContractorsDocumentsFilteredList.vue";

  import { Company, User } from "@/generated/graphql";

  @Component({
    components: {
      ContractorsDocumentsFileredList,
    },
  })
  export default class DocumentsAdminContractors extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;


    get query() {
      return {
       "company_id": { "_eq": this.company.id },
      };
    }
  }
